export default __webpack_public_path__ + "static/media/logo.e8c9e71e.svg";